/* =============================================
   FWG Stickers & Labels — Form JS
   ============================================= */

var FWG_CONFIG = {
  SUPABASE_URL: 'https://yjpllbljqrczkfhodozi.supabase.co',
  SUPABASE_ANON_KEY: 'sb_publishable_9aGFQdl82HAw23uFfSIjCA_d4Qmi6Bp',
  API_URL: 'https://ops.frederickwraps.com',
  THANK_YOU_URL: '/pages/thank-you',
  STORAGE_BUCKET: 'form-uploads'
};

var TOTAL_STEPS = 3;
var currentStep = 1;
var completedSteps = new Set();

/* ── CDN Image Base ── */
var CDN = 'https://cdn.shopify.com/s/files/1/0856/5902/5698/files/';

/* ── Shape Images by Type ── */
var SHAPE_CONFIG = {
  'die-cut': [
    { value:'contoured', label:'Contoured', img: CDN + 'Die-Cut_Contoured.jpg?v=1739161441' },
    { value:'circle', label:'Circle', img: CDN + 'Die-Cut_Circle.jpg?v=1739161453' },
    { value:'rounded-corners', label:'Rounded Corners', img: CDN + 'Die-Cut_Square_Rounded.jpg?v=1739161439' },
    { value:'sharp-corners', label:'Sharp Corners', img: CDN + 'Die-cut_Square.jpg?v=1739161436' }
  ],
  'kiss-cut': [
    { value:'contoured', label:'Contoured', img: CDN + 'EZ_Contoured.jpg?v=1739162515' },
    { value:'circle', label:'Circle', img: CDN + 'EZ_Circle.jpg?v=1739162515' },
    { value:'rounded-corners', label:'Rounded Corners', img: CDN + 'EZ_Rounded.jpg?v=1739162515' },
    { value:'sharp-corners', label:'Sharp Corners', img: CDN + 'EZ_Square.jpg?v=1739162515' }
  ],
  'sticker-sheets': [
    { value:'contoured', label:'Contoured', img: CDN + 'EZ_Sheet_Contoured.jpg?v=1739163893' },
    { value:'circle', label:'Circle', img: CDN + 'EZ_Sheet_Circle.jpg?v=1739163893' },
    { value:'rounded-corners', label:'Rounded Corners', img: CDN + 'EZ_Sheet_Rounded.jpg?v=1739163893' },
    { value:'sharp-corners', label:'Sharp Corners', img: CDN + 'EZ_Sheet_Square.jpg?v=1739163893' }
  ],
  'roll-labels': [
    { value:'circle', label:'Circle', img: CDN + 'Roll_Circles.jpg?v=1739164286' },
    { value:'rounded-corners', label:'Rounded Corners', img: CDN + 'Roll_Rounded.jpg?v=1739164287' },
    { value:'sharp-corners', label:'Sharp Corners', img: CDN + 'Roll_Square.jpg?v=1739164287' }
  ]
};

/* ── Display Names ── */
var displayNames = {
  type: { 'die-cut':'Die-Cut Stickers', 'kiss-cut':'Kiss-Cut / Easy Peel', 'sticker-sheets':'Sticker Sheets', 'roll-labels':'Roll Labels' },
  material: { vinyl:'Vinyl', holographic:'Holographic', clear:'Clear', 'low-tack':'Low Tack / Wall', unsure:'Not Sure' },
  shape: { contoured:'Contoured', circle:'Circle', 'rounded-corners':'Rounded Corners', 'sharp-corners':'Sharp Corners', custom:'Custom / Other' },
  finish: { gloss:'Gloss', matte:'Matte', unsure:'Not Sure' },
  timeline: { standard:'Standard (5–7 days)', rush:'\uD83D\uDD36 Rush (2–3 days)', urgent:'\uD83D\uDD34 Urgent (24–48 hrs)', same_day:'\uD83D\uDEA8 Same Day — URGENT', flexible:'No Rush — Flexible' }
};

/* ── Stepper Navigation ── */
function goToStep(target) {
  if (target < 1 || target > TOTAL_STEPS || target === currentStep) return;
  var isForward = target > currentStep;
  if (isForward) {
    for (var s = currentStep; s < target; s++) {
      var errors = getStepErrors(s);
      if (errors.length > 0) {
        highlightErrors(s, errors);
        showToast('Please fill in all required fields');
        return;
      }
      completedSteps.add(s);
    }
  }
  if (!isForward && getStepErrors(currentStep).length === 0) {
    completedSteps.add(currentStep);
  }
  switchCard(target);
}

function switchCard(target) {
  var currentCard = document.querySelector('.form-page-sticker .step-card[data-step="' + currentStep + '"]');
  if (currentCard) currentCard.classList.remove('active');
  if (target === TOTAL_STEPS) buildSummary();
  var targetCard = document.querySelector('.form-page-sticker .step-card[data-step="' + target + '"]');
  if (targetCard) {
    void targetCard.offsetWidth;
    targetCard.classList.add('active');
  }
  currentStep = target;
  updateStepper();
  var stepper = document.getElementById('stickerStepper');
  if (stepper) stepper.scrollIntoView({ behavior:'smooth', block:'start' });
}

function updateStepper() {
  document.querySelectorAll('.form-page-sticker .step-indicator').forEach(function(ind) {
    var step = parseInt(ind.dataset.step);
    ind.classList.remove('active', 'completed');
    if (step === currentStep) ind.classList.add('active');
    else if (completedSteps.has(step)) ind.classList.add('completed');
  });
}

/* ── Validation ── */
function getStepErrors(stepNum) {
  var errors = [];
  switch (stepNum) {
    case 1:
      if (!document.getElementById('stickerFullName').value.trim()) errors.push('stickerFullName');
      var em = document.getElementById('stickerEmail').value.trim();
      if (!em || em.indexOf('@') === -1) errors.push('stickerEmail');
      if (!document.getElementById('stickerContactMethodHidden').value) errors.push('contactMethod');
      break;
    case 2:
      if (!document.getElementById('stickerTypeHidden').value) errors.push('typeGrid');
      if (!document.getElementById('stickerShapeHidden').value) errors.push('shapeGrid');
      if (!document.getElementById('stickerMaterialHidden').value) errors.push('materialGrid');
      if (!document.getElementById('stickerSizeHidden').value) errors.push('sizePills');
      // Custom size validation
      var sizeVal = document.getElementById('stickerSizeHidden').value;
      if (sizeVal === 'custom') {
        var w = parseFloat(document.getElementById('customWidth').value);
        var h = parseFloat(document.getElementById('customHeight').value);
        if (!w || w <= 0) errors.push('customWidth');
        if (!h || h <= 0) errors.push('customHeight');
      }
      // Qty validation
      var qtyHidden = getSelectedQty();
      if (!qtyHidden) errors.push('qtyPills');
      if (qtyHidden === 'custom') {
        var cq = document.getElementById('customQty').value;
        if (!cq || parseInt(cq) <= 0) errors.push('customQty');
      }
      // Timeline validation
      if (!document.getElementById('stickerTimeline').value) errors.push('stickerTimeline');
      break;
  }
  return errors;
}

function getSelectedQty() {
  var selected = document.querySelector('.form-page-sticker .qty-pill.selected');
  return selected ? selected.dataset.value : null;
}

function highlightErrors(stepNum, errors) {
  clearErrors();
  var card = document.querySelector('.form-page-sticker .step-card[data-step="' + stepNum + '"]');
  if (!card) return;
  card.classList.remove('shake');
  void card.offsetWidth;
  card.classList.add('shake');
  errors.forEach(function(errKey) {
    switch(errKey) {
      case 'stickerFullName': case 'stickerEmail': case 'customWidth': case 'customHeight': case 'customQty': case 'stickerTimeline':
        var el = document.getElementById(errKey);
        if (el) el.closest('.field-group') ? el.closest('.field-group').classList.add('field-error') : null;
        break;
      case 'contactMethod':
        var cm = document.querySelector('.form-page-sticker .contact-method-group');
        if (cm) cm.closest('.field-group').classList.add('field-error');
        break;
      case 'typeGrid': case 'materialGrid': case 'finishGrid':
        var grid = document.getElementById(errKey);
        if (grid) grid.closest('.field-group').classList.add('field-error');
        break;
      case 'shapeGrid':
        var sg = document.getElementById('shapeGroup');
        if (sg) sg.classList.add('field-error');
        break;
      case 'sizePills':
        var sp = document.getElementById('sizePills');
        if (sp) sp.closest('.field-group').classList.add('field-error');
        break;
      case 'qtyPills':
        var qp = document.getElementById('qtyPills');
        if (qp) qp.closest('.field-group').classList.add('field-error');
        break;
    }
  });
}

function clearErrors() {
  document.querySelectorAll('.form-page-sticker .field-error').forEach(function(el) { el.classList.remove('field-error'); });
}

document.addEventListener('input', function(e) {
  if (e.target.closest('.form-page-sticker')) clearErrors();
});
document.addEventListener('click', function(e) {
  if (e.target.closest('.form-page-sticker .selection-btn, .form-page-sticker .contact-method-btn, .form-page-sticker .size-pill, .form-page-sticker .qty-pill')) {
    clearErrors();
  }
});

/* ── Contact Method ── */
function selectContactMethod(btn) {
  document.querySelectorAll('.form-page-sticker .contact-method-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('stickerContactMethodHidden').value = btn.dataset.value;
}

/* ── Generic Grid Select ── */
function selectGrid(field, el) {
  el.closest('.selection-grid').querySelectorAll('.selection-btn').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  document.getElementById('sticker' + field.charAt(0).toUpperCase() + field.slice(1) + 'Hidden').value = el.dataset.value;
}

/* ── Type Selection (rebuilds shapes & toggles material) ── */
function selectType(el) {
  el.closest('.selection-grid').querySelectorAll('.selection-btn').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  var type = el.dataset.value;
  document.getElementById('stickerTypeHidden').value = type;

  // Clear shape selection since shapes change per type
  document.getElementById('stickerShapeHidden').value = '';

  // Rebuild shape grid
  buildShapeGrid(type);

  // Toggle holographic for roll labels
  var holoBtn = document.getElementById('materialHolographic');
  if (type === 'roll-labels') {
    holoBtn.style.display = 'none';
    // If holographic was selected, clear it
    if (document.getElementById('stickerMaterialHidden').value === 'holographic') {
      holoBtn.classList.remove('selected');
      document.getElementById('stickerMaterialHidden').value = '';
    }
  } else {
    holoBtn.style.display = '';
  }

  // Show/hide roll size info
  updateRollSizeUI();
}

/* ── Build Shape Grid Dynamically ── */
function buildShapeGrid(type) {
  var container = document.getElementById('shapeGrid');
  var shapes = SHAPE_CONFIG[type];
  if (!shapes) {
    container.innerHTML = '<div class="shape-placeholder">Select a sticker type above to see available shapes</div>';
    return;
  }

  var html = '<div class="selection-grid">';
  shapes.forEach(function(s) {
    html += '<div class="selection-btn" data-value="' + s.value + '" onclick="selectShape(this)">';
    html += '<img class="selection-btn__img" src="' + s.img + '" alt="' + s.label + '">';
    html += s.label;
    html += '</div>';
  });
  // Add Custom/Other option (no image)
  html += '<div class="selection-btn" data-value="custom" onclick="selectShape(this)">Custom / Other</div>';
  html += '</div>';
  container.innerHTML = html;
}

function selectShape(el) {
  el.closest('.selection-grid').querySelectorAll('.selection-btn').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  document.getElementById('stickerShapeHidden').value = el.dataset.value;
}

/* ── Size Selection ── */
function selectSize(el) {
  document.querySelectorAll('.form-page-sticker .size-pill').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  var val = el.dataset.value;
  document.getElementById('stickerSizeHidden').value = val;
  document.getElementById('customSizeGroup').style.display = val === 'custom' ? 'block' : 'none';
  updateRollSizeUI();
}

/* ── Quantity Selection ── */
function selectQty(el) {
  document.querySelectorAll('.form-page-sticker .qty-pill').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  document.getElementById('customQtyGroup').style.display = el.dataset.value === 'custom' ? 'block' : 'none';
}

/* ── Roll Label Size Constraints ── */
var ROLL_MAX_SHORT = 4.5;
var ROLL_MAX_LONG = 17;

function isRollLabel() {
  return document.getElementById('stickerTypeHidden').value === 'roll-labels';
}

function updateRollSizeUI() {
  var isRoll = isRollLabel();
  var isCustom = document.getElementById('stickerSizeHidden').value === 'custom';
  var infoEl = document.getElementById('rollSizeInfo');
  infoEl.style.display = (isRoll && isCustom) ? 'flex' : 'none';
  if (!isRoll || !isCustom) {
    document.getElementById('rollSizeWarn').style.display = 'none';
    document.getElementById('customWidth').classList.remove('size-input-capped');
    document.getElementById('customHeight').classList.remove('size-input-capped');
    document.getElementById('customWidth').removeAttribute('max');
    document.getElementById('customHeight').removeAttribute('max');
  }
}

function enforceRollConstraints(changed) {
  if (!isRollLabel()) return;

  var wInput = document.getElementById('customWidth');
  var hInput = document.getElementById('customHeight');
  var w = parseFloat(wInput.value) || 0;
  var h = parseFloat(hInput.value) || 0;
  var warnEl = document.getElementById('rollSizeWarn');
  var warnText = document.getElementById('rollSizeWarnText');

  // Reset styles
  wInput.classList.remove('size-input-capped');
  hInput.classList.remove('size-input-capped');
  warnEl.style.display = 'none';

  // Hard cap at 17
  if (changed === 'width' && w > ROLL_MAX_LONG) {
    wInput.value = ROLL_MAX_LONG;
    w = ROLL_MAX_LONG;
  }
  if (changed === 'height' && h > ROLL_MAX_LONG) {
    hInput.value = ROLL_MAX_LONG;
    h = ROLL_MAX_LONG;
  }

  // Cross-constraint: if one side > 4.5, other must be <= 4.5
  if (changed === 'width' && w > ROLL_MAX_SHORT) {
    hInput.setAttribute('max', ROLL_MAX_SHORT);
    if (h > ROLL_MAX_SHORT) {
      hInput.value = ROLL_MAX_SHORT;
    }
    hInput.classList.add('size-input-capped');
    warnText.textContent = 'Width is over 4.5" — height capped at 4.5" (printer max).';
    warnEl.style.display = 'flex';
  } else if (changed === 'width') {
    hInput.removeAttribute('max');
    // But check if height was already > 4.5
    if (h > ROLL_MAX_SHORT) {
      wInput.setAttribute('max', ROLL_MAX_SHORT);
      if (w > ROLL_MAX_SHORT) {
        wInput.value = ROLL_MAX_SHORT;
      }
      wInput.classList.add('size-input-capped');
      warnText.textContent = 'Height is over 4.5" — width capped at 4.5" (printer max).';
      warnEl.style.display = 'flex';
    } else {
      wInput.removeAttribute('max');
    }
  }

  if (changed === 'height' && h > ROLL_MAX_SHORT) {
    wInput.setAttribute('max', ROLL_MAX_SHORT);
    if (w > ROLL_MAX_SHORT) {
      wInput.value = ROLL_MAX_SHORT;
    }
    wInput.classList.add('size-input-capped');
    warnText.textContent = 'Height is over 4.5" — width capped at 4.5" (printer max).';
    warnEl.style.display = 'flex';
  } else if (changed === 'height') {
    wInput.removeAttribute('max');
    if (w > ROLL_MAX_SHORT) {
      hInput.setAttribute('max', ROLL_MAX_SHORT);
      if (h > ROLL_MAX_SHORT) {
        hInput.value = ROLL_MAX_SHORT;
      }
      hInput.classList.add('size-input-capped');
      warnText.textContent = 'Width is over 4.5" — height capped at 4.5" (printer max).';
      warnEl.style.display = 'flex';
    } else {
      hInput.removeAttribute('max');
    }
  }
}

/* ── Phone Formatting ── */
function formatPhone(input) {
  var val = input.value.replace(/\D/g, '');
  if (val.length > 10) val = val.substring(0, 10);
  if (val.length >= 7) { input.value = '(' + val.substring(0,3) + ') ' + val.substring(3,6) + '-' + val.substring(6); }
  else if (val.length >= 4) { input.value = '(' + val.substring(0,3) + ') ' + val.substring(3); }
  else if (val.length > 0) { input.value = '(' + val; }
}

/* ── File Upload ── */
function handleFiles(input) {
  var el = document.getElementById('designFileNames');
  el.textContent = input.files.length ? 'Selected: ' + Array.from(input.files).map(function(f) { return f.name; }).join(', ') : '';
}

/* ── Review Summary ── */
function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
function summaryRow(label, value) { return '<div class="summary__row"><span class="summary__label">' + label + '</span><span class="summary__value">' + (value || '<span style="color:#555;">\u2014</span>') + '</span></div>'; }
function editBtn(step) { return '<button type="button" class="btn-edit" onclick="goToStep(' + step + ')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg> Edit</button>'; }
function sectionHeader(num, title, step) { return '<div class="summary__section-header"><div class="summary__section-title"><span class="summary__section-num">' + num + '</span> ' + title + '</div>' + editBtn(step) + '</div>'; }

function buildSummary() {
  var html = '';

  // 1. Contact
  html += '<div class="summary__section">' + sectionHeader('01', 'Contact Info', 1);
  html += summaryRow('Name', esc(document.getElementById('stickerFullName').value));
  html += summaryRow('Email', esc(document.getElementById('stickerEmail').value));
  var phone = document.getElementById('stickerPhone').value.trim();
  if (phone) html += summaryRow('Phone', esc(phone));
  var company = document.getElementById('stickerCompany').value.trim();
  if (company) html += summaryRow('Company', esc(company));
  var cm = document.getElementById('stickerContactMethodHidden').value;
  html += summaryRow('Contact Via', cm === 'email' ? 'Email' : cm === 'text' ? 'Text' : cm === 'call' ? 'Call' : '');
  html += '</div>';

  // 2. Sticker Details
  html += '<div class="summary__section">' + sectionHeader('02', 'Sticker Details', 2);
  var type = document.getElementById('stickerTypeHidden').value;
  html += summaryRow('Type', displayNames.type[type] || '');
  var shape = document.getElementById('stickerShapeHidden').value;
  html += summaryRow('Shape', displayNames.shape[shape] || shape || '');
  var mat = document.getElementById('stickerMaterialHidden').value;
  html += summaryRow('Material', displayNames.material[mat] || '');

  // Size
  var sizeVal = document.getElementById('stickerSizeHidden').value;
  var sizeDisplay = sizeVal;
  if (sizeVal === 'custom') {
    var w = document.getElementById('customWidth').value;
    var h = document.getElementById('customHeight').value;
    sizeDisplay = (w && h) ? w + '" \u00D7 ' + h + '"' : 'Custom';
  } else if (sizeVal) {
    sizeDisplay = sizeVal + '"';
  }
  html += summaryRow('Size', sizeDisplay);

  // Qty
  var qtyPill = document.querySelector('.form-page-sticker .qty-pill.selected');
  var qtyVal = qtyPill ? qtyPill.dataset.value : '';
  var qtyDisplay = qtyVal;
  if (qtyVal === 'custom') {
    qtyDisplay = document.getElementById('customQty').value || 'Custom';
  } else if (qtyVal === '1000') {
    qtyDisplay = '1,000+';
  }
  html += summaryRow('Quantity', qtyDisplay);

  var fin = document.getElementById('stickerFinishHidden').value;
  if (fin) html += summaryRow('Finish', displayNames.finish[fin] || fin);

  // Files
  var fileInput = document.querySelector('input[name="sticker_design_files"]');
  if (fileInput && fileInput.files.length) {
    html += summaryRow('Design Files', Array.from(fileInput.files).map(function(f) { return esc(f.name); }).join(', '));
  }

  var notes = document.getElementById('stickerNotes').value.trim();
  if (notes) html += summaryRow('Notes', esc(notes));

  var tl = document.getElementById('stickerTimeline').value;
  html += summaryRow('Timeline', displayNames.timeline[tl] || tl || '');

  html += '</div>';

  document.getElementById('stickerSummaryContainer').innerHTML = html;
}

/* ── Toast ── */
function showToast(m) {
  var t = document.getElementById('stickerToast');
  t.textContent = m;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2200);
}

/* ── File Upload to Supabase ── */
function uploadFile(file, folder) {
  var timestamp = Date.now();
  var safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  var path = folder + '/' + timestamp + '_' + safeName;
  return fetch(
    FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path,
    {
      method: 'POST',
      headers: {
        'apikey': FWG_CONFIG.SUPABASE_ANON_KEY,
        'Authorization': 'Bearer ' + FWG_CONFIG.SUPABASE_ANON_KEY,
        'Content-Type': file.type,
        'x-upsert': 'true'
      },
      body: file
    }
  ).then(function(response) {
    if (!response.ok) {
      return response.text().then(function(t) { console.error('Upload failed:', file.name, t); return null; });
    }
    return FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/public/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path;
  });
}

function uploadFiles(fileInput, folder) {
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) return Promise.resolve([]);
  var promises = [];
  for (var i = 0; i < fileInput.files.length; i++) {
    promises.push(uploadFile(fileInput.files[i], folder));
  }
  return Promise.all(promises).then(function(urls) {
    return urls.filter(function(u) { return u !== null; });
  });
}

/* ── Submit Handler ── */
document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('fwgStickerForm').addEventListener('submit', function(e) {
    e.preventDefault();

    // Validate all steps
    for (var i = 1; i <= TOTAL_STEPS; i++) {
      var errors = getStepErrors(i);
      if (errors.length > 0) {
        switchCard(i);
        (function(step, errs) {
          setTimeout(function() { highlightErrors(step, errs); }, 50);
        })(i, errors);
        showToast('Please fill in all required fields');
        return;
      }
    }

    var submitBtn = document.querySelector('.form-page-sticker .btn-submit');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;"><svg width="18" height="18" viewBox="0 0 24 24" style="animation:spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="31 31" stroke-linecap="round"/></svg> Submitting...</span>';
    }

    var submissionId = Date.now() + '_' + Math.random().toString(36).substring(2, 8);
    var folder = 'submissions/' + submissionId;
    var designInput = document.querySelector('input[name="sticker_design_files"]');

    uploadFiles(designInput, folder + '/designs')
    .then(function(designUrls) {
      var sizeVal = document.getElementById('stickerSizeHidden').value;
      var qtyPill = document.querySelector('.form-page-sticker .qty-pill.selected');

      var payload = {
        form_type: 'sticker_label',
        contact_name: document.getElementById('stickerFullName').value.trim(),
        email: document.getElementById('stickerEmail').value.trim(),
        phone: document.getElementById('stickerPhone').value.trim() || null,
        company: document.getElementById('stickerCompany').value.trim() || null,
        contact_method: document.getElementById('stickerContactMethodHidden').value,
        sticker_type: document.getElementById('stickerTypeHidden').value,
        shape: document.getElementById('stickerShapeHidden').value,
        material: document.getElementById('stickerMaterialHidden').value,
        size: sizeVal === 'custom' ? {
          width: document.getElementById('customWidth').value,
          height: document.getElementById('customHeight').value
        } : sizeVal,
        quantity: qtyPill ? (qtyPill.dataset.value === 'custom' ? document.getElementById('customQty').value : qtyPill.dataset.value) : null,
        finish: document.getElementById('stickerFinishHidden').value || null,
        timeline: document.getElementById('stickerTimeline').value,
        notes: document.getElementById('stickerNotes').value.trim() || null,
        additional_info: document.getElementById('stickerAdditionalInfo').value.trim() || null,
        design_file_urls: designUrls,
        source_page: window.location.pathname,
        user_agent: navigator.userAgent
      };

      return fetch(FWG_CONFIG.API_URL + '/api/submissions/public', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .then(function(response) {
      if (!response.ok) {
        return response.text().then(function(t) { throw new Error('Submission failed: ' + t); });
      }
      showToast('Inquiry submitted! We\'ll be in touch within 24 hours.');
      setTimeout(function() {
        window.location.href = FWG_CONFIG.THANK_YOU_URL;
      }, 800);
    })
    .catch(function(err) {
      console.error('Form submission error:', err);
      showToast('Something went wrong. Please try again or call us directly.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  });
});
